import React from "react";

const PretsCredits = () => {
  return (
    <div className="prets-credits">
      <h2>Prêts et crédits</h2>
      <p>Suivi des prêts et crédits en cours.</p>
    </div>
  );
};

export default PretsCredits;
